import Rating from '@/components/Rating';
import type { ProductRoot } from '../types/product';

export const ProductRating = ({ product, onViewReviews }: { product: ProductRoot; onViewReviews: () => void }) => {
  const fixedRating = Math.floor(product.rating_summary / 2) / 10;

  return (
    <div className='flex items-center justify-start gap-x-2.5 lg_mt-[5px] '>
      <div className='flex items-center gap-x-[7px]'>
        <Rating
          disabled
          rating={product.rating_summary}
        />
        <span className='text-xs leading-[17px] lg_text-aba6a0 '>{fixedRating}</span>
      </div>
      <span className='text-E7DED5'>|</span>
      <span
        className='cursor-pointer text-xs leading-[17px] underline lg_text-aba6a0 lg_no-underline lg_hover_text-80583F'
        onClick={onViewReviews}
      >
        {product.review_count} Reviews
      </span>
    </div>
  );
};
